// extracted by mini-css-extract-plugin
export default {"taxes":"components_taxes--zRU","taxesItem":"components_taxesItem--z1c"};